import type { History } from "history";
import type { ReactNode } from "react";
import type { HistoryUnsubscribe } from "react-router-redux";

import { useLocationAndHistorySync } from "./useLocationAndHistorySync";
import { useMountedMessage } from "./useMountedMessage";

export const SidekickProvider = (props: {
  children: ReactNode;
  history: History & HistoryUnsubscribe;
}) => {
  useLocationAndHistorySync(props.history);
  useMountedMessage();
  return props.children;
};
